<style>
  .contents {
    margin: -0.2em 0em 0em 0em; /* top | right | bottom | left */
  }
  .item {
    margin: 0.2em;
    align-items: center;
  }
  .widget {
    margin: 0.2em;
    flex: 1 1 auto;
  }
</style>

<script>
  import config from '../../config';
  import { config_values, meteo_data } from '../store';
  import MeteoWidget from './MeteoWidget.svelte';
   
  function get_items(widget_type) {
    let items = [];
    if ($config_values[widget_type].chosen) {
      items.push($config_values[widget_type].chosen);
    } else {
      for (let key of Object.keys($config_values[widget_type])) {
        if ($config_values[widget_type][key].visible) {
          items.push(key);
        }
      }
    }
    items.sort();
    return items;
  }
  
  export let next_order;
  export let prev_order;
  export let prev_ids;
  
  let widget_id = prev_ids[prev_ids.length - 1];
  let widget_type = prev_order[prev_order.length - 1];
  let value = '[nezināms]';
  let unit = '';
  $: {
    if (next_order.length === 0) {
      let loc_key = prev_ids[prev_order.indexOf('location')];
      let loc_id = $config_values.location[loc_key].id;
      let prov_key = prev_ids[prev_order.indexOf('provider')];
      let prov_id = $config_values.provider[prov_key].id;
      let time_key = prev_ids[prev_order.indexOf('time')];
      let time_id = $config_values.time[time_key].id;
      
      let current_time = Date.now();
      let time_diff = Number(time_id);
      let forecast_time = current_time + time_diff * 3600 * 1000;
      let time = new Date(forecast_time).toISOString().slice(0, 13);
      
      let param_key = prev_ids[prev_order.indexOf('param')];
      let param_id = $config_values.param[param_key].id;
      if (
        $meteo_data[prov_id]
        && $meteo_data[prov_id][loc_id]
        && $meteo_data[prov_id][loc_id].data
        && $meteo_data[prov_id][loc_id].data.forecast
        && $meteo_data[prov_id][loc_id].data.forecast[time]
      ) {
        value = $meteo_data[prov_id][loc_id].data.forecast[time][param_id];
        unit = $meteo_data[prov_id][loc_id].data.meta.units[param_id];
        if (config.units[unit]) {
          unit = config.units[unit];
        }
      }
    }
  }
</script>

<div class='widget vertical show-border'>
  <div class='caption-center horiz-always unselectable'>
    {#if $config_values[widget_type].choices}
      <p>{$config_values[widget_type].choices[widget_id].name}</p>
    {:else}
      <p>{$config_values[widget_type][widget_id].name}</p>
    {/if}
  </div>
  {#if next_order.length === 0}
    <div class='center horiz-always'>
      <p class='big'>{value} {unit}</p>
    </div>
  {:else if next_order.length === 1}
  <div class='contents horiz-wrap'>
    {#each get_items(next_order[0]) as key}
      <MeteoWidget next_order={next_order.slice(1)} prev_order={prev_order.concat(next_order[0])} prev_ids={prev_ids.concat(key)} />
    {/each}
  </div>
  {:else}
    <div class='contents vertical'>
      {#each get_items(next_order[0]) as key}
        <MeteoWidget next_order={next_order.slice(1)} prev_order={prev_order.concat(next_order[0])} prev_ids={prev_ids.concat(key)} />
      {/each}
    </div>
  {/if}
</div>
